/**
 * ProfileStats — a lightweight, typographic reading-stats strip. Deliberately
 * not a dashboard: no cards, no icons-in-boxes, just numbers set large in
 * the display face with a label underneath, separated by hairline dividers.
 */

import React from 'react';
import { motion } from 'framer-motion';
import { fadeUp, stagger } from '@/lib/motion';
import { PROFILE } from '@/constants/testIds';

function Stat({ value, label }) {
  return (
    <motion.div variants={fadeUp} className="px-5 text-center first:pl-0 last:pr-0 sm:px-8">
      <p className="font-display text-3xl font-semibold text-ink sm:text-4xl">{value}</p>
      <p className="mt-1 text-xs font-medium uppercase tracking-wide text-subtle">{label}</p>
    </motion.div>
  );
}

export default function ProfileStats({ booksRead, streak, scribbles, tbr }) {
  return (
    <motion.div
      variants={stagger}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.6 }}
      data-testid={PROFILE.stats}
      className="u-container mt-10 flex items-center justify-center divide-x divide-line sm:justify-start"
    >
      <Stat value={booksRead} label="Books Read" />
      <Stat value={streak} label="Day Streak" />
      <Stat value={scribbles} label="Scribbles" />
      <Stat value={tbr} label="TBR" />
    </motion.div>
  );
}
